import React, { useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog, IconButton,
    Paper, Radio, TextField, FormControlLabel, RadioGroup, Box, Grid,
    Button, MenuItem, FormControl, InputLabel, Select,
    Checkbox,
    Typography,
    Tooltip,
    Autocomplete
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios'
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Snackbar from '@mui/material/Snackbar';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { addCNS, addUnit, editDeleteCNS, editDeleteUnit, getBankList, getStateList } from '../../../actions/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import styles from '.././../../styles.module.css';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { makeStyles } from '@mui/styles';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});

function PartiesAdd(props) {
    const classes = useStyles();
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();
    // const editInfo = props.details;
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const editData = editInfo && editInfo;
    const editid = editData && editData.CSNId;
    const [successMessage, setSuccessMessage] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [openSnak, setOpenSnak] = React.useState(false);

    const [data, setData] = useState({
        id: editid,
        CNS_Name: editData ? editData.CNS_Name : '',
        CNS_Type: props.CNSTYPE === 'All' ? editData ? editData.CNS_Type : 'Customer' : editData ? editData.CNS_Type : props.CNSTYPE,
        supplierType: editData ? editData.supplierType : '',
        contactPerson: editData ? editData.contactPerson : '',
        mobileNo: editData ? editData.mobileNo : '',
        emailId: editData ? editData.emailId : '',
        gstn: editData ? editData.gstn : '',
        panNo: editData ? editData.panNo : '',
        creditLimit: editData ? editData.creditLimit : 0,
        openingBalance: editData ? editData.openingBalance : 0,
        creditPeriod: editData ? editData.creditPeriod : 0,
        vendorCode: editData ? editData.vendorCode : '',
        address: editData ? editData.address : '',
        city: editData ? editData.city : '',
        pinCode: editData ? editData.pinCode : '',
        accountNumber: editData ? editData.accountNumber : '',
        availCNS_Type: editData ? editData.availCNS_Type : false,
    });

    const [selectCheck, setSelectCheck] = useState(editData ? editData.balanceType : data.CNS_Type === 'Customer' ? 'toCollect' : 'toPay');

    const handleChangeRadio = event => {
        setSelectCheck(event.target.value);
    }
    const [bank, setBank] = useState(editData ? editData.bank : null);
    const [state, setState] = useState(editData ? editData.state : null);

    const handleChangeBank = (event, newValue) => {
        setBank(newValue)
    }

    const handleChangeState = (event, newValue) => {
        setState(newValue)
    }
    const [CNS_JoiningDate, setCNS_JoiningDate] = React.useState(editData ? dayjs(editData.CNS_JoiningDate) : dayjs(new Date()));
    const handleChange1 = (newValue) => {
        setCNS_JoiningDate(newValue);
    };

    const bankList = useSelector(state => state.bank.bank)
    const stateList = useSelector(state => state.allStates.allStates)

    const date_ob = new Date();
    const hours = date_ob.getHours();
    const minutes = date_ob.getMinutes();
    const seconds = date_ob.getSeconds();
    const milliseconds = date_ob.getMilliseconds();
    const currentTime = hours + ":" + minutes + ":" + seconds + ":" + milliseconds;
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISODateTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleOpenSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnak(false);
        setOpen(false);
    }

    const handleCloseSnak = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnak(false);
    };

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;

        if (target.name === 'CNS_Type') {
            if (target.value === 'Customer') {
                setSelectCheck('toCollect')
            } else {
                setSelectCheck('toPay')
            }
        }
    }

    useEffect(() => {
        dispatch(getBankList({ companyId: userInfo.companyId }))
        dispatch(getStateList())

        if (editid) {
            setBank({
                bankName: editData.bankName,
                id: editData.bank,
            })
            setState({
                name: editData.state,
            })
        }

    }, []);

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.CNS.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'party name already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
        const sending_data = {
            companyId: userInfo.companyId,
            ...data,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
            balanceType: selectCheck,
            bank: bank.id,
            CNS_JoiningDate: dateConversionOnEntryPage(CNS_JoiningDate),
            state: state.name,
        }
        if (editData) {
            dispatch(editDeleteCNS(sending_data));
        } else {
            dispatch(addCNS(sending_data));
        }
        // props.onAPISubmt();
        // props.handleCloseDialog();
    }

    const action = (
        <React.Fragment>
            <Button size="small" id="btnYes" onClick={handleOpenSnack}>
                Yes
            </Button>
            <Button size="small" id="btnNo" onClick={handleCloseSnak}>
                No
            </Button>
        </React.Fragment>
    );

    return (
        <>
            <div>
            <Breadcrumb
                            routeSegments={[
                                { name: 'Masters', path: '/masters/' },
                                { name: 'Party List', path: '/masters/party-masters' },
                                { name: 'Create Party' },
                            ]}
                        />
                <Paper className={`${styles.list_container}`}>
                
                     <Box sx={{ m: 4}} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1} sx={{ mt: 0 , paddingLeft: '30px' }}>
                           
                            <>
                                <Grid item xs={2} className={`${styles.grid_lable}`}>
                                    <Typography className={`${styles.erp_lable}`} >Party Type</Typography>
                                </Grid>
                                <Grid item xs={4} className={`${styles.grid_input}`}>
                                    <ERPinput
                                        size='small'
                                        fullWidth
                                        name="CNS_Type"
                                        onChange={handleChange}
                                        value={(data.CNS_Type)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{readOnly: data.availCNS_Type === true ? true : false}}
                                        select
                                        required
                                    >
                                        <MenuItem value="Customer" className={`${styles.erp_lable}`}>Customer</MenuItem>
                                        <MenuItem value="Supplier" className={`${styles.erp_lable}`}>Supplier</MenuItem>
                                    </ERPinput>
                                </Grid>
                            </>
                            {/* } */}
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >Party Name</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    fullWidth
                                    name="CNS_Name"
                                    value={(data.CNS_Name)}
                                    size='small'
                                    onChange={(e) => handleChange(e)}
                                    type="text"
                                    required
                                />
                            </Grid>
                            {(data.CNS_Type) === "Supplier" &&
                                <>
                                    <Grid item xs={2} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`} >Supplier Type</Typography>
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_input}`}>
                                        <ERPinput

                                            size='small'
                                            fullWidth
                                            name="supplierType"
                                            onChange={handleChange}
                                            value={(data.supplierType)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            select
                                        >
                                            <MenuItem value="" selected disabled className={`${styles.erp_lable}`}>Select Type</MenuItem>
                                            <MenuItem value="Material Supplier" className={`${styles.erp_lable}`}>Material Supplier</MenuItem>
                                            <MenuItem value="Subcontractor" className={`${styles.erp_lable}`}>Subcontractor</MenuItem>
                                        </ERPinput>
                                    </Grid>
                                </>
                            }
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >Address</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <TextField
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: 85,
                                            fontSize: 12,
                                        },
                                    }}
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="address"
                                    multiline
                                    rows={4}
                                    value={(data.address)}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>City</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="city"
                                    value={(data.city)}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Pin Code</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="txet"
                                    onChange={handleChange}
                                    name="pinCode"
                                    value={(data.pinCode)}

                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >State</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <Autocomplete
                                    fullWidth
                                    classes={{
                                        option: classes.option,
                                    }}
                                    noOptionsText={
                                        <span className={classes.noOptionsLabel}>No options</span>
                                    }
                                    options={stateList}
                                    value={state}
                                    onChange={handleChangeState}
                                    getOptionLabel={(option) => option.name}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    renderInput={(params) => <ERPinput required {...params} />}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >Mobile No</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    fullWidth
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="mobileNo"
                                    value={(data.mobileNo)}
                                    size='small'
                                    onChange={(e) => handleChange(e)}
                                    type="text"

                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>E-mail ID</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="emailId"
                                    value={data.emailId}

                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Contact Person</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="contactPerson"
                                    value={(data.contactPerson)}

                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >GST No</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="gstn"
                                    value={(data.gstn)}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>PAN No</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="panNo"
                                    value={(data.panNo)}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Credit Limit</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    onChange={handleChange}
                                    name="creditLimit"
                                    value={(data.creditLimit)}
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Credit Period (Days)</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    type="number"
                                    onChange={handleChange}
                                    name="creditPeriod"
                                    value={(data.creditPeriod)}

                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >Opening Balance</Typography>
                            </Grid>
                            <Grid item xs={1.5} >
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    onChange={handleChange}
                                    name="openingBalance"
                                    value={data.openingBalance}
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={2.5}>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel
                                        control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                        id='toCollect'
                                        name="selectCheck"
                                        value="toCollect"
                                        onChange={handleChangeRadio}
                                        checked={selectCheck === 'toCollect'}
                                        label={<span style={{ fontSize: '12px' }}> To Collect</span>}
                                    />
                                    <FormControlLabel
                                        control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                        id='toPay'
                                        name="selectCheck"
                                        value="toPay"
                                        onChange={handleChangeRadio}
                                        checked={selectCheck === 'toPay'}
                                        label={<span style={{ fontSize: '12px' }}> To Pay</span>}
                                    />
                                </RadioGroup>
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Joining Date</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        name="CNS_JoiningDate"
                                        inputFormat="DD/MM/YYYY"
                                        // inputFormat="DD/MM/YYYY"
                                        value={CNS_JoiningDate}
                                        onChange={handleChange1}
                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                            fullWidth />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >Vendor Code</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="vendorCode"
                                    value={(data.vendorCode)}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Add Bank</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <Autocomplete
                                    fullWidth
                                    classes={{
                                        option: classes.option,
                                    }}
                                    noOptionsText={
                                        <span className={classes.noOptionsLabel}>No options</span>
                                    }
                                    options={bankList}
                                    value={bank}
                                    onChange={handleChangeBank}
                                    getOptionLabel={(option) => option.bankName}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderInput={(params) => <ERPinput required  {...params} />}
                                />
                            </Grid>
                            <Grid item xs={12} className={`${styles.grid_input}`}>
                                <Box sx={{ marginTop: '12px', float: 'right' }}>
                                    <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                    <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} /> {editData ? 'Update' : 'Save'}
                                    </Button>
                                    <Cancel />
                                </Box>
                            </Grid>
                        </Grid>

                    </form>
                </Paper>
                <Snackbar
                    open={openSnak}
                    autoHideDuration={4000}
                    onClose={handleCloseSnak}
                    message="Do you wish to close without saving ?"
                    action={action}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                />
                {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
            </div>
        </>
    )
}

export default PartiesAdd